<template>
    <div ref="pageBox">
        <LabelContent title="基本信息" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" :model="searchParams" :rules="search" ref="search"
                     label-width="110px" class="unitWidth" size="small">
                <el-form-item label="工装编码" prop="toolingCode">
                    <el-input v-model.trim="searchParams.toolingCode" placeholder="请输入工装编码(必填)"
                              :disabled="ifAdd ? false : true"></el-input>
                </el-form-item>
                <el-form-item label="工装名称" prop="toolingName">
                    <el-input v-model.trim="searchParams.toolingName" placeholder="请输入工装名称(必填)"></el-input>
                </el-form-item>
                <el-form-item label="工装图号">
                    <el-input v-model.trim="searchParams.toolingTuhao" placeholder="请输入工装图号"></el-input>
                </el-form-item>
                <el-form-item label="工装规格">
                    <el-input v-model.trim="searchParams.toolingSpecs" placeholder="请输入工装规格"></el-input>
                </el-form-item>
                <el-form-item label="工装品牌">
                    <el-input v-model.trim="searchParams.toolingBrand" placeholder="请输入工装品牌"></el-input>
                </el-form-item>
                <el-form-item label="单位">
                    <el-select v-model="searchParams.unit" placeholder="请选择单位" clearable filterable>
                        <el-option
                            v-for="unit in unitList"
                            :key="unit.unitId"
                            :label="unit.unitDesc"
                            :value="unit.unitDesc">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工厂" prop="fcIdSelected">
                    <el-select v-model="fcIdSelected" placeholder="请选择所属工厂(必填)" :disabled="fcShow" :clearable="isclear"
                               @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择所属车间" clearable filterable @change="shopChange">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择所属工段" clearable filterable @change="sectionChange">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择所属产线" clearable filterable>
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工装分类" prop="classifyId">
                    <el-select v-model="searchParams.classifyId" placeholder="请选择工装分类" clearable filterable
                               @change="selectChange">
                        <el-option
                            v-for="classify in classifyList"
                            :key="classify.tcId"
                            :label="classify.classifyName"
                            :value="classify.tcId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商编号">
                    <el-input v-model.trim="searchParams.supplierCode" placeholder="请输入供应商编号"></el-input>
                </el-form-item>
                <el-form-item label="供应商名称">
                    <el-input v-model.trim="searchParams.supplierName" placeholder="请输入供应商名称"></el-input>
                </el-form-item>
                <el-form-item label="设计寿命">
                    <el-input-number v-model.trim="searchParams.designLife" :min="0" placeholder="请输入设计寿命 （次）"
                                     @change="getLife">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余寿命">
                    <el-input-number v-model.trim="searchParams.residualLife" :min="0" placeholder="请输入剩余寿命（次）"
                                     :disabled="true">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="寿命到期提醒">
                    <el-input-number v-model.trim="searchParams.lifeDueRemind" :min="0" placeholder="请输入寿命到期提醒（次）" :disabled="lifeShow">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="到期日期">
                    <el-date-picker
                        :picker-options="pickerOptions"
                        v-model="searchParams.dueDate"
                        type="date"
                        placeholder="选择到期日期"
                        @change="getDateShow"
                        @focus="donnes">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="到期提醒日期">
                    <el-date-picker
                        :disabled="dateShow"
                        :picker-options="pickerOptions"
                        v-model="searchParams.dateDueRemind"
                        type="date"
                        placeholder="选择到期日期"
                        @blur="selectChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="进厂日期" prop="arrivalDate">
                    <el-date-picker
                        v-model="searchParams.arrivalDate"
                        type="date"
                        placeholder="选择到期日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="工装状态">
                    <el-select v-model="searchParams.toolingStatus" placeholder="请选择工装状态(必填)">
                        <el-option
                            v-for="enumType in enumTypeList"
                            :key="enumType.etId"
                            :label="enumType.etName"
                            :value="enumType.etCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="位置编号">
                    <el-input v-model.trim="searchParams.locatorCode" placeholder="请输入位置编号"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="searchParams.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updateLingInfo('search')">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="工装记录" ref="LabelContent" v-if="ifAdd ? false : true">
        </LabelContent>
        <div class="tableBox" v-if="ifAdd ? false : true">
            <el-table stripe ref="multipleTable" :data="toolingInfoLogList" class="center">
                <el-table-column prop="operationModel.desc" sortable label="操作日志" width="110"/>
                <el-table-column prop="userName" sortable label="操作人" width="110"/>
                <el-table-column prop="createTime" sortable label="操作时间" width="160"/>
                <el-table-column prop="operationType.desc" sortable label="操作类型" width="110"/>
                <el-table-column prop="operationDesc" sortable label="操作内容"/>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { getToolingCode, unitList } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'addlingInfo',
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                searchParams: {
                    toolingCode: '',
                    toolingName: '',
                    toolingTuhao: '',
                    toolingSpecs: '',
                    toolingBrand: '',
                    remark: '',
                    unit: '',
                    classifyId: '',
                    supplierCode: '',
                    supplierName: '',
                    designLife: '',
                    residualLife: '',
                    prodDate: new Date(),
                    dueDate: '',
                    toolingStatus: '',
                    locatorCode: '',
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    arrivalDate: '',
                    lifeDueRemind: '',
                    dateDueRemind: ''
                },
                lifeShow: true,
                dateShow: true,
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                search: {
                    toolingCode: [
                        {
                            required: true,
                            message: '请输入工装编码',
                            trigger: 'blur'
                        }
                    ],
                    toolingName: [
                        {
                            required: true,
                            message: '请输入工装名称',
                            trigger: 'blur'
                        }
                    ],
                    classifyId: [
                        {
                            required: true,
                            message: '请选择工装分类',
                            trigger: 'change'
                        }
                    ],
                    arrivalDate: [
                        {
                            required: true,
                            message: '请选择进厂日期',
                            trigger: 'blur'
                        }
                    ]
                },
                classifyList: [],
                unitList: [],
                ifAddText: '',
                ifAdd: false,
                fcShow: false,
                enumTypeList: [],
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                toolingInfoLogList: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                this.ifAddText = this.$route.params.ifAddText
                if (this.ifAddText == undefined || this.ifAddText == '') {
                    this.ifAddText = JSON.parse(sessionStorage.getItem('ifAddText'))
                }
                if (this.ifAddText == '0') {
                    this.searchParams = {}
                    this.ifAdd = true
                    this.fcShow = false
                    this.searchParams.toolingStatus = 'id_le'
                    sessionStorage.setItem('ifAddText', JSON.stringify(this.ifAddText))
                } else {
                    this.ifAdd = false
                    this.fcShow = true
                    sessionStorage.setItem('ifAddText', JSON.stringify(this.ifAddText))
                    if (this.$route.params.lingInfo != undefined && this.$route.params.lingInfo != '') {
                        this.searchParams = this.$route.params.lingInfo
                        sessionStorage.setItem('lingInfo', JSON.stringify(this.searchParams))
                    } else {
                        this.searchParams = JSON.parse(sessionStorage.getItem('lingInfo'))
                    }
                }
                /*if(this.ifAdd){
                    var arr = Math.round(Math.random()*100)
                    var dateArr = moment(new Date()).format('YYYYMMDDHHmmss')
                    this.searchParams.toolingCode = 'TOOLING' + dateArr + arr
                }*/
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                        this.fcShow = true
                    }
                }
                if (this.searchParams.designLife != undefined && this.searchParams.designLife != '') {
                    this.lifeShow = false
                } else {
                    this.lifeShow = true
                }
                if (this.searchParams.dueDate != undefined && this.searchParams.dueDate != '') {
                    this.dateShow = false
                } else {
                    this.dateShow = true
                }
                this.getData()
                this.getUnitList()
                this.getEunmTypeList()
                this.getToolingInfoLogList()
            },
            getToolingCode(){
                let params = {
                    toolingCode: this.searchParams.toolingCode,
                    fcCode: this.searchParams.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getToolingCode,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.searchParams = JSON.parse(JSON.stringify(response.data))
                        }
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            getLife() {
                /*if (this.ifAdd) {
                    this.searchParams.residualLife = this.searchParams.designLife
                }*/
                this.searchParams.residualLife = this.searchParams.designLife
                if (this.searchParams.designLife != undefined && this.searchParams.designLife != '') {
                    this.searchParams.lifeDueRemind = Math.ceil(this.searchParams.designLife * 0.05)
                    this.lifeShow = false
                } else {
                    this.searchParams.lifeDueRemind = ''
                    this.lifeShow = true
                }
            },
            getDateShow() {
                if (this.searchParams.dueDate != undefined && this.searchParams.dueDate != '') {
                    this.dateShow = false
                    let currentTime = new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()
                    let dateDueR = new Date(moment(this.searchParams.dueDate).subtract(30, "days").format('YYYY-MM-DD')).getTime()
                    if (dateDueR >= currentTime) {
                        //subtract(30, “days”) 的意思是向前推30天，如果是1，就是向前推1天
                        this.searchParams.dateDueRemind = moment(this.searchParams.dueDate).subtract(30, "days").format('YYYY-MM-DD')
                    } else {
                        this.searchParams.dateDueRemind = ''
                    }
                } else {
                    this.dateShow = true
                    this.searchParams.dateDueRemind = ''
                }
                // 强制刷新
                this.$forceUpdate();
            },
            donnes() {
                var arrTime = []
                for (let i = 0; i < 1; i++) {
                    var tempDate = new Date() // 获取今天的日期
                    tempDate.setDate(tempDate.getDate() + i) // 今天的前N天的日期，N自定义
                    arrTime.push(moment(tempDate).format('YYYY-MM-DD'))
                }
                this.pickerOptions = {
                    disabledDate(time) {
                        for (let i = 0; i < arrTime.length; i++) {
                            let date = new Date(arrTime[i])
                            const day = new Date(new Date(date.toLocaleDateString()).getTime() + 1000 * 60 * 60 * 24)
                            if (time.getTime() === day.getTime() - 24 * 60 * 60 * 1000) {
                                return true
                            }
                        }
                        if (time) {
                            return time.getTime() < Date.now() - 8.64e7
                        }
                    }
                }
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.searchParams.classifyId = ''
                this.getToolingClassifyList()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
            },
            sectionChange: function() {
                this.lineSelected = ''
            },
            selectChange() {
                this.$forceUpdate()
            },
            updateLingInfo(search) {
                this.$refs[search].validate((valid) => {
                    if (valid) {
                        var url = ''
                        /*if (this.ifAdd) {
                            url = this.$api.addToolingInfo
                        } else {
                            url = this.$api.editToolingInfo
                        }*/
                        this.ifAdd ? url = this.$api.addToolingInfo : url = this.$api.editToolingInfo
                        this.addLingInfo(url)
                    } else {
                        return false
                    }
                })
            },
            addLingInfo(url) {
                if (this.searchParams.toolingCode == undefined || this.searchParams.toolingCode == '') {
                    this.$message.info('请输入工装编码！')
                    return
                }
                if (this.searchParams.toolingName == undefined || this.searchParams.toolingName == '') {
                    this.$message.info('请输入工装名称！')
                    return
                }
                if (this.searchParams.classifyId == undefined || this.searchParams.classifyId == '') {
                    this.$message.info('请选择工装分类！')
                    return
                }
                /*if (this.searchParams.toolingTuhao == undefined || this.searchParams.toolingTuhao == '') {
                    this.$message.info('请输入工装图号！')
                    return
                }
                if (this.searchParams.toolingSpecs == undefined || this.searchParams.toolingSpecs == '') {
                    this.$message.info('请输入工装规格！')
                    return
                }
                if (this.searchParams.toolingBrand == undefined || this.searchParams.toolingBrand == '') {
                    this.$message.info('请输入工装品牌！')
                    return
                }
                if (this.searchParams.remark == undefined || this.searchParams.remark == '') {
                    this.$message.info('请输入备注！')
                    return
                }
                if (this.searchParams.unit == undefined || this.searchParams.unit == '') {
                    this.$message.info('请选择单位！')
                    return
                }*/
                if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                /*if (this.searchParams.supplierCode == undefined || this.searchParams.supplierCode == '') {
                    this.$message.info('请输入供应商编码！')
                    return
                }
                if (this.searchParams.supplierName == undefined || this.searchParams.supplierName == '') {
                    this.$message.info('请输入供应商名称！')
                    return
                }*/
                /*if (this.searchParams.designLife == undefined || this.searchParams.designLife == '') {
                    this.$message.info('请输入设计寿命！')
                    return
                }
                if (this.searchParams.residualLife == undefined || this.searchParams.residualLife == '') {
                    this.$message.info('请输入剩余寿命！')
                    return
                }
                if (this.searchParams.dueDate == undefined || this.searchParams.dueDate == '') {
                    this.$message.info('请选择到期时间！')
                    return
                }*/
                if (((this.searchParams.designLife == undefined || this.searchParams.designLife == '') &&
                    (this.searchParams.residualLife == undefined || this.searchParams.residualLife == '')) &&
                    (this.searchParams.dueDate == undefined || this.searchParams.dueDate == '')) {
                    this.$message.error('请选择到期时间或者寿命！')
                    return
                }
                if (this.searchParams.designLife != undefined && this.searchParams.designLife != '') {
                    if (this.searchParams.lifeDueRemind == undefined || this.searchParams.lifeDueRemind == '') {
                        this.$message.error('请输入寿命到期提醒！')
                        return
                    }
                }
                if (this.searchParams.dueDate != undefined && this.searchParams.dueDate != '') {
                    if (this.searchParams.dateDueRemind == undefined || this.searchParams.dateDueRemind == '') {
                        this.$message.error('请选择到期提醒日期！')
                        return
                    }
                }
                if (this.searchParams.arrivalDate != undefined && this.searchParams.arrivalDate != '') {
                    this.searchParams.arrivalDate = moment(this.searchParams.arrivalDate).format('YYYY-MM-DD')
                }
                /*if (this.searchParams.toolingStatus == undefined || this.searchParams.toolingStatus == '') {
                    this.$message.info('请选择工装状态！')
                    return
                }
                if (this.searchParams.locatorCode == undefined || this.searchParams.locatorCode == '') {
                    this.$message.info('请输入位置编码！')
                    return
                }*/
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    this.searchParams.fcCode = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    this.searchParams.shopCode = JSON.parse(this.shopSelected).deptCode
                } else {
                    this.searchParams.shopCode = ''
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    this.searchParams.sectionCode = JSON.parse(this.sectionSelected).deptCode
                } else {
                    this.searchParams.sectionCode = ''
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    this.searchParams.lineCode = JSON.parse(this.lineSelected).deptCode
                } else {
                    this.searchParams.lineCode = ''
                }
                if (this.searchParams.dueDate != undefined && this.searchParams.dueDate != '') {
                    this.searchParams.dueDate = moment(this.searchParams.dueDate).format('YYYY-MM-DD')
                }
                if (this.searchParams.dateDueRemind != undefined && this.searchParams.dateDueRemind != '') {
                    this.searchParams.dateDueRemind = moment(this.searchParams.dateDueRemind).format('YYYY-MM-DD')
                }
                let options = {
                    method: 'POST',
                    url: url,
                    data: this.searchParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success(this.ifAdd == true ? '新增成功！' : '编辑成功！')
                        this.$router.push({
                            name: 'toolingInfo'
                        })
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            getData() {
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                let self = this
                this.$http.request(options).then(response => {
                    self.factoryTree = response.data
                    if (self.ifAdd && self.ischeck) {
                        for (var i = 0; i < self.factoryTree.length; i++) {
                            if (self.factoryTree[i].deptID == self.role.factoryId) {
                                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                            }
                        }
                    } else {
                        for (var i = 0; i < self.factoryTree.length; i++) {
                            var factorys = self.factoryTree[i]
                            if (factorys.hasOwnProperty('deptCode')) {
                                if (factorys.deptCode == self.searchParams.fcCode) {
                                    var arr = []
                                    arr.push({
                                        label: factorys.deptName,
                                        id: factorys.deptID,
                                        value: JSON.stringify(factorys.child),
                                        deptLevel: factorys.deptLevel,
                                        parent: 0,
                                        child: factorys.child
                                    })
                                    self.fcIdSelected = JSON.stringify(factorys)
                                }
                            }
                            var shop = factorys.child
                            for (var j = 0; j < shop.length; j++) {
                                if (shop[j].hasOwnProperty('deptCode')) {
                                    if (shop[j].deptCode == self.searchParams.shopCode) {
                                        var arr = []
                                        arr.push({
                                            label: shop[j].deptName,
                                            id: shop[j].deptID,
                                            value: JSON.stringify(shop[j].child),
                                            deptLevel: shop[j].deptLevel,
                                            parent: 0,
                                            child: shop[j].child
                                        })
                                        self.shopSelected = JSON.stringify(shop[j])
                                    }
                                }
                                var vsm = shop[j].child
                                for (var v = 0; v < vsm.length; v++) {
                                    if (vsm[v].hasOwnProperty('deptCode')) {
                                        if (vsm[v].deptCode == self.searchParams.sectionCode) {
                                            var arr = []
                                            arr.push({
                                                label: vsm[v].deptName,
                                                id: vsm[v].deptID,
                                                value: JSON.stringify(vsm[v].child),
                                                deptLevel: vsm[v].deptLevel,
                                                parent: 0,
                                                child: vsm[v].child
                                            })
                                            self.sectionSelected = JSON.stringify(vsm[v])
                                        }
                                    }
                                    var line = vsm[v].child
                                    for (var l = 0; l < line.length; l++) {
                                        if (line[l].hasOwnProperty('deptCode')) {
                                            if (line[l].deptCode == self.searchParams.lineCode) {
                                                var arr = []
                                                arr.push({
                                                    label: line[l].deptName,
                                                    id: line[l].deptID,
                                                    value: JSON.stringify(line[l].child),
                                                    deptLevel: line[l].deptLevel,
                                                    parent: 0,
                                                    child: line[l].child
                                                })
                                                self.lineSelected = JSON.stringify(line[l])
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    self.getToolingClassifyList()
                    if (!this.ifAdd) {
                        self.getToolingCode()
                    }
                })
            },
            getToolingClassifyList() {
                let params = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.toolingClassifyList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.classifyList = response.data
                    }
                })
            },
            getUnitList() {
                let options = {
                    method: 'get',
                    url: this.$api.unitList
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.unitList = response.data
                    }
                })
            },
            getEunmTypeList() {
                this.enumTypeList = []
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.enumTypelist,
                    params: {
                        enumType: 'tool_status'
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.enumTypeList = [
                            {
                                etName: '闲置中',
                                etCode: 'id_le'
                            },
                            {
                                etName: '领用中',
                                etCode: 'in_use'
                            },
                            {
                                etName: '报废中',
                                etCode: 'scrap'
                            },
                            {
                                etName: '调试中',
                                etCode: 'debugging'
                            },
                            {
                                etName: '使用中',
                                etCode: 'make_use'
                            },
                            {
                                etName: '已移管',
                                etCode: 'moved_tube'
                            }
                        ]
                        if (response.data != undefined && response.data != '') {
                            self.enumTypeList = []
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                var array = {
                                    etName: '',
                                    etCode: ''
                                }
                                array.etName = aa[i].etName
                                array.etCode = aa[i].etCode
                                self.enumTypeList.push(array)
                            }
                        }
                    }
                })
            },
            getToolingInfoLogList(){
                this.toolingInfoLogList = []
                let params = {
                    fcCode: this.searchParams.fcCode,
                    toolingCode: this.searchParams.toolingCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.toolingInfoLogList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        if(response.data != undefined && response.data != ''){
                            this.toolingInfoLogList = response.data
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
